export default "__VITE_ASSET__Ch_RNaRe__"